import { Component } from "@angular/core";
import { ITooltipAngularComp } from "ag-grid-angular";
import { ITooltipParams } from 'ag-grid-community';


@Component({
    selector: 'tooltip-component',
    template: ` <div class="safetytooltip">
    <span>{{ data }}</span>
    </div>`,
    styles: [
        `
      .safetytooltip {
        background-color: black;
        opacity: 0.75;
        color: white;
        display: inline-block;
        white-space: pre-line;
        width: 500px;
      }
      `,
    ],
    standalone: false // NOSONAR
})

export class SafetyTooltip implements ITooltipAngularComp {

    public data: any;
    public field: string;

    agInit(params: { field: string } & ITooltipParams): void {
        this.data = params.data.incidentSummary;
        console.info('data...',this.data);
    }
}
